import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class CustomValidators {
	static authorNameForCourse(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			const value = control.value;
			if (!value) return null;
            const regex =/^(?=.*[A-Za-z0-9])[A-Za-z0-9 !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/;
			return regex.test(value) ? null : { authorPattern: true };
		};
	}

	static yearRangeForCourse(minYear: number, maxYear: number): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			const val = control.value;
			if (val === '' || val === null) return { required: true };
			if (!/^\d{4}$/.test(val)) return { pattern: true };
			const year = Number(val);
			if (year < minYear || year > maxYear) return { range: true };
			return null;
		};
	}
}